export class DisableFeatures {

  // For Firebase
  $key: string;

  disableMenuPageTitle: boolean;
  disableSpeakerSessions: boolean;

  disableMySessionAndroid: boolean;
  disableMySessionApple: boolean;

  disableQuizAndroid: boolean;
  disableQuizApple: boolean;

  disableLeaderboardAndroid: boolean;
  disableLeaderboardApple: boolean;

  disableGalleryAndroid: boolean;
  disableGalleryApple: boolean;

  disableNotificationsAndroid: boolean;
  disableNotificationsApple: boolean;

  disableAbstractAndroid: boolean;
  disableAbstractApple: boolean;

  disableSecurityAndroid: boolean;
  disableSecurityApple: boolean;

  disableNotesAndroid: boolean;
  disableNotesApple: boolean;

  disableAttendeesAndroid: boolean;
  disableAttendeesApple: boolean;

  constructor() {
  }
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/disableFeatures.ts